import { ReactElement, ReactNode } from 'react';

import styled from 'styled-components';

import { Button, ButtonProps } from '@components/button';
import { IconProps } from '@components/icons';
import { InfoBoxProps } from '@components/info-box';
import { Container } from '@components/info-box/info-box';
import { Text } from '@components/text';
import { pxToRem } from '@utils/converters';

export type BannerProps = {
  title: string | ReactNode;
  icon?: ReactElement<IconProps>;
  buttonProps?: ButtonProps;
  variant?: InfoBoxProps['variant'];
};

export const Banner = (props: BannerProps) => {
  const { title, icon, buttonProps, variant } = props;

  return (
    <StyledBanner data-variant={variant}>
      <div style={{ width: pxToRem(640) }}>
        <Text text={title} />
      </div>
      {icon && (
        <Shadow>
          <icon.type color="elementPurple50" size={100} {...icon.props} />
        </Shadow>
      )}
      {buttonProps && <Button {...buttonProps} style={{ zIndex: 1, ...buttonProps.style }} />}
    </StyledBanner>
  );
};

export const StyledBanner = styled(Container)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  padding: `${pxToRem(20)} ${pxToRem(24)}`,
});

const Shadow = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  right: 0,
  bottom: 0,
});
